import { jsx } from "react/jsx-runtime";
import { Box } from "../Box/Box.mjs";
import { Link } from "../Link/Link.mjs";
import { useMenuItem } from "./useMenuItem.mjs";
const MenuItemLink = ({
  href,
  target,
  rel,
  onClick,
  tone,
  data,
  children,
  badge,
  icon,
  id
}) => {
  const { menuItemProps, MenuItemChildren } = useMenuItem({
    displayName: "MenuItemLink",
    onClick,
    tone,
    data,
    id
  });
  return /* @__PURE__ */ jsx(
    Box,
    {
      component: Link,
      ...menuItemProps,
      href,
      target,
      rel,
      children: /* @__PURE__ */ jsx(MenuItemChildren, { tone, leftSlot: icon, badge, children })
    }
  );
};
MenuItemLink.__isMenuItem__ = true;
export {
  MenuItemLink
};
